/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { recipesAdapter } from '../../adapters/recipesAdapter';
import { setFullCart } from './cartHydrationActions';

interface PortionChangePayload {
    recipeId: string;
    portions: number;
}

const slice = createSlice({
    name: 'recipes',
    initialState: recipesAdapter.getInitialState(),
    reducers: {
        removeRecipe: (state, action: PayloadAction<string>) => {
            recipesAdapter.removeOne(state, action.payload);
        },
        changeRecipePortions: (state, action: PayloadAction<PortionChangePayload>) => {
            recipesAdapter.updateOne(state, {
                id: action.payload.recipeId,
                changes: { portions: action.payload.portions },
            });
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.recipes);
    },
});

export const { actions: cartRecipeActions } = slice;

export default slice.reducer;
